import { createFileRoute } from '@tanstack/react-router'
import { PacketBearerPage } from '../features/portal/packet-link'

/** An already-emailed work-order bearer. The page drops the token from the address bar, then POSTs it. */
export const Route = createFileRoute('/w/$token')({
  component: function PacketTokenRoute() {
    const { token } = Route.useParams()
    return <PacketBearerPage token={token} />
  },
})
